var render, staticRenderFns
import script from "./ConfettiLogo.vue?vue&type=script&lang=ts"
export * from "./ConfettiLogo.vue?vue&type=script&lang=ts"
import style0 from "./ConfettiLogo.vue?vue&type=style&index=0&id=26380432&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26380432",
  null
  
)

export default component.exports